// ** Reducers Imports
import navbar from './navbar';
import layout from './layout';
import auth from './authentication';
import permission from './permission';
import crudApis from './allCrudeStore';
import Tabs from './Tabs';
import notifications from './notifications';
import pagination from './pagination';

const rootReducer = {
    auth,
    navbar,
    layout,
    permission,
    Tabs,
    notifications,
    pagination,
    ...crudApis
};

export default rootReducer;
